module.exports = __webpack_public_path__ + "img/olympiclogo.b145ed79.svg";